// @flow
import React, { useCallback, useEffect, useRef, useState } from "react";
import "./custom.css"
import logo from "../../../../../images/login-logo.png"
import axios from "axios";
import { batch, connect, useDispatch } from "react-redux";
import { translate } from "../../../base/i18n";

import Toast from 'react-simple-toasts';
import Loader from 'react-loader';

import { ValidateEmail, _ValidateIPaddress, ValidateUsername, ValidatePassword, apiVersion } from "../Utils";
import { checkUserSession, userLogin, userSignup } from "../Request.d";
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from "../../constant";
import { hideApiLoader, setLoginModal, setUserIsLogin, setUserLoginData, showApiLoader } from "../../redux/tool-webjam/actions";
import { messages } from "../messages";
import Config from '../../config';
import { sendAnalytics } from "../../../analytics";
import { getBaseConfig } from "../../Utils";
import { Constant } from "../../../webjam/constant";
import { updateSettings } from "../../../base/settings";
import { ct, dynamicMessageLocale } from "../../constant-Utils";
import { PushSpinner } from "../../custom/components/PushSpinner";

const { socket_endpoint } = Config;

const Input = (props) => {
    return (
        <div className="form-group">
            <input
                className="form-control"
                {...props}
            />
        </div>
    )
}

let date = new Date();
var today = date.getDate() + "-" + date.getMonth() + "-" + date.getFullYear()

const Login = (props) => {

    const dispatch = useDispatch();
    const { loadingShow } = props;
    const [isLogin, setIsLogin] = useState(true);
    const [isForgot, setIsForgot] = useState(false);
    const [isMaskEye, setIsMaskEye] = useState(true);

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        username: ''
    });

    const [ipAddr, setIpAddr] = useState({
        systemIp: "",
        localIp: ""
    })

    useEffect(() => {
        if (props.dashboardLogin) {
            if (sessionStorage.getItem("OpenSignup")) {
                sessionStorage.removeItem("OpenSignup");
                setIsLogin(false)
            } else {
                setIsLogin(true)
            }
        }
    }, [props.dashboardLogin])

    useEffect(() => {
        // axios.get('https://ipv4.icanhazip.com')
        //     .then(response => {
        //         if (response && response.data && _ValidateIPaddress(response.data)) {
        //             window.getUserIP((ip) => {
        //                 setIpAddr({
        //                     systemIp: ip,
        //                     localIp: response.data
        //                 })
        //             });
        //         } else {
        //             axios.get('https://ifconfig.me/ip')
        //                 .then(response => {
        //                     window.getUserIP((ip) => {
        //                         setIpAddr({
        //                             systemIp: ip,
        //                             localIp: response.data
        //                         })
        //                     });
        //                 })
        //                 .catch(error => {
        //                     console.log(error);
        //                 });
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error);
        //     });



        let getLocalAuth = localStorage.getItem("auth");
        if (getLocalAuth) {
            getLocalAuth = JSON.parse(getLocalAuth);
            if (getLocalAuth.hasOwnProperty("token")) {
                // dispatch(showApiLoader())
                checkUserSession(getLocalAuth.token, "login main file")
                    .then((res) => {
                        dispatch(hideApiLoader())
                        if (res?.status == 1) {
                            dispatch(setLoginModal(false));
                            dispatch(setUserIsLogin(true));
                        }

                        // else if (localStorage.getItem("isGuest")) {
                        //     if (localStorage.getItem("isGuest") == today) {
                        //         dispatch(setLoginModal(false));
                        //     }
                        // }
                    });
                setTimeout(function () {
                    dispatch(hideApiLoader())
                }, 10000)
            }
        } else {
            // if (localStorage.getItem("isGuest")) {
            //     if (localStorage.getItem("isGuest") == today) {
            //         // dispatch(setLoginModal(false));
            //         setTimeout(function () {
            //             dispatch(setLoginModal(false));
            //         }, 2000)
            //     }
            // }
        }

        return () => {
            sessionStorage.removeItem("OpenSignup")
            setFormData({
                email: '',
                password: '',
                username: ''
            })
        }

    }, [])

    useEffect(() => {
        setFormData({
            email: '',
            password: '',
            username: ''
        })
    }, [isLogin])

    const handleInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleGuest = () => {
        localStorage.setItem("isGuest", today)
        dispatch(setLoginModal(false));
    }

    const handleFormSubmit = (e) => {
        const { authOrganization } = props;
        e.preventDefault();
        //let willMove = true;

        if (!formData.email) {
            Toast(ct("messages.emailRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        } else if (!ValidateEmail(formData.email)) {
            Toast(ct("messages.emailInvalid", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        } else if (!isLogin && !formData.username) {
            //willMove = false;
            Toast(ct("messages.usernameRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        } else if (!isLogin && formData.username.length < 3) {
            //willMove = false;
            Toast(ct("messages.usernameLen", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        } else if (!isLogin && !ValidateUsername(formData.username)) {
            //willMove = false;
            Toast(ct("messages.usernameInvalid", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        } else if (!formData.password) {
            Toast(ct("messages.passwordRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        } else if (!isLogin && formData.password.length < 6) {
            setFormData({
                ...formData,
                password: ''
            });
            Toast(ct("messages.passwordLen", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        } else if (!isLogin && !ValidatePassword(formData.password)) {
            setFormData({
                ...formData,
                password: ''
            });
            Toast(ct("messages.passwordInvalid", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        }
        //} else {
        // let willMove = true;
        // if (!isLogin) {
        //     if (!formData.username) {
        //         willMove = false;
        //         Toast(messages.usernameRequired)
        //     } else if (formData.username.length < 2) {
        //         willMove = false;
        //         Toast(messages.usernameLen)
        //     }
        // }

        //if (willMove) {

        console.log("form data sending ", formData)
        const payload = {
            ...formData,
            // ...ipAddr,
            // browser: window.detectDevice(),
            // browser: "chrome",
            // remember: true,
            organization_id: authOrganization?._id
        }

        let request = "";
        if (isLogin) {
            request = userLogin(payload)
        } else {
            request = userSignup(payload)
        }
        dispatch(showApiLoader())

        request.then(async (res) => {
            if (res.status == 1) {
                if (res.data) {
                    //localStorage.setItem("auth", JSON.stringify(res.data));
                    //console.log("res.data.data.username: ", res.data.username);
                    localStorage.setItem("username", res.data.username);
                    let saveData = res.data;

                    let sessionData = {
                        email: saveData.email,
                        id: saveData.id,
                        refreshToken: saveData.refreshToken,
                        token: saveData.token,
                        username: saveData.username
                    }

                    localStorage.setItem("auth", JSON.stringify(sessionData));

                    // if (saveData.hasOwnProperty("stripe_account_id")) {
                    //     if (saveData.stripe_account_id != "") {
                    //         sessionData = Object.assign({
                    //             stripe_account_id: "true",
                    //             connectVerified: saveData.connectVerified
                    //         }, sessionData)
                    //     }
                    // }

                    // if (saveData.hasOwnProperty("stripe_customer_id")) {
                    //     if (saveData.stripe_customer_id != "") {
                    //         sessionData = Object.assign({
                    //             stripe_customer_id: "true"
                    //         }, sessionData)
                    //     }
                    // }
                    // localStorage.setItem("auth", JSON.stringify(sessionData));

                    const {
                        userLoginData
                    } = props;

                    dispatch(updateSettings({
                        displayName: saveData.username
                    }));

                    dispatch(setUserLoginData({
                        ...userLoginData,
                        user: {
                            ...userLoginData.user,
                            ...sessionData
                        }
                    }, 12))

                    if (isLogin) {
                        Toast(ct("messages.loginSuccess", "messages"), Constant.App.ToastTime.LongCloseTime);
                        sendAnalytics({
                            action: 'sign-in',
                            source: "welcome",
                            category: "login"
                        });
                    } else {
                        Toast(ct("messages.signupSuccess", "messages"), Constant.App.ToastTime.LongCloseTime);
                        sendAnalytics({
                            action: 'sign-up',
                            source: "welcome",
                            category: "register"
                        });
                    }

                    setFormData({
                        email: '',
                        password: '',
                        username: ''
                    })

                    dispatch(setUserIsLogin(true));
                    // setTimeout(function () {
                    dispatch(setLoginModal(false));
                    //dispatch(setUserIsLogin(true));
                    // }, 200);
                } else {
                    if (res.data != '') {
                        let msg = await dynamicMessageLocale(res.data.message);
                        Toast(msg, Constant.App.ToastTime.LongCloseTime)
                    }
                }
            } else {
                if (res.data != '') {
                    let msg = await dynamicMessageLocale(res.data.message);
                    Toast(msg, Constant.App.ToastTime.LongCloseTime)
                }
            }
        }).catch(e => {
            // console.log("errooor", e)
        })
            .finally(e => {
                dispatch(hideApiLoader());
            });
        //}
        //}
    }

    const forgotPass = () => {

        setFormData({
            email: '',
            password: '',
            username: ''
        })

        setIsForgot(true);
    }

    const maskEye = (type) => {
        let passInput = document.getElementById("login-password-input")
        if (passInput) {
            if (type) {
                passInput.setAttribute("type", "password")
            } else {
                passInput.setAttribute("type", "text")
            }
        }
        setIsMaskEye(type);
    }

    const sendMail = (e) => {
        const { authOrganization } = props
        e.preventDefault();
        if (!formData.email) {
            Toast(ct("messages.emailRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
        } else if (!ValidateEmail(formData.email)) {
            Toast(ct("messages.emailInvalid", "messages"), Constant.App.ToastTime.LongCloseTime);
        } else {
            const config = {
                headers: {
                    'content-type': 'application/json'
                }
            };
            dispatch(showApiLoader())
            //axios.post(`${socket_endpoint + apiVersion}/send_reset_link`, {
            axios.post(`${socket_endpoint + (getBaseConfig("apiVersion") || apiVersion)}/send_reset_link`, {
                email: formData.email,
                organization_id: authOrganization?._id
            }, config).then(async response => {

                dispatch(hideApiLoader())
                if (response.data.status) {

                    setFormData({
                        email: '',
                        password: '',
                        username: ''
                    })

                    setTimeout(async () => {
                        let msg = await dynamicMessageLocale(response.data.message);
                        Toast(msg, Constant.App.ToastTime.LongCloseTime);
                    }, 200);
                    setIsForgot(false);
                } else {
                    let msg = await dynamicMessageLocale(response.data.message);
                    Toast(msg, Constant.App.ToastTime.LongCloseTime);
                }
                sendAnalytics({
                    action: 'forgot-password',
                    source: "welcome",
                    category: "forgot password"
                });
            }).catch(error => {
                Toast(ct("messages.contactAdmin", "messages"), Constant.App.ToastTime.LongCloseTime);
            });
        }
    }

    const { dashboardLogin } = props;
    const loginLogo = getBaseConfig("loginLogo");

    return (
        <>
            <div className="main login">
                {loadingShow &&
                    <>
                        {getBaseConfig("showPushSpinnerLoader") ?
                            <div className="loader-text-container D">
                                <div className='loader-wrapper'>
                                    <PushSpinner
                                        size={30}
                                        color="white"
                                        loading={true}
                                        className={"loader-text-main"}
                                    />
                                </div>
                            </div>
                            :
                            <Loader
                                loaded={false}
                                options={{ color: "white" }}
                            ></Loader>
                        }
                    </>
                }
            </div>

            {
                dashboardLogin &&

                <div className="container-login text-center">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12 login-container">
                            <div className="login-pane">
                                <div className="logo-pane">
                                    {/* <img src={logo} className="login-logo" /> */}
                                    <img src={loginLogo} className="login-logo" />
                                </div>

                                <div className="card">
                                    {
                                        isLogin ? <>

                                            {isForgot ? <>
                                                <div>
                                                    <div className="login-text-pane">
                                                        <h2 className="login-text text-left">{ct("rta-trmc.signInSignUpPage.resetPassword")}</h2>
                                                    </div>

                                                    <div className="card-body">
                                                        <form className="w-100">
                                                            <Input
                                                                name="email"
                                                                type="email"
                                                                value={formData.email}
                                                                placeholder="Enter Email Address"
                                                                onChange={handleInput}
                                                            />
                                                            <div className="form-group">
                                                                <div className="pull-left forgot-pass-container" >
                                                                    <span className="font-15 theme-font pointer"
                                                                        onClick={() => setIsForgot(false)}
                                                                    >{ct("rta-trmc.signInSignUpPage.backToSignIn")}
                                                                    </span>
                                                                </div>
                                                                <button className="btn float-right login-btn mb-3" id="reset-pwd-btn" onClick={sendMail}>
                                                                    {ct("rta-trmc.signInSignUpPage.sendEmail")}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </> : <>
                                                <div className="login-text-pane">
                                                    <h2 className="login-text text-left">{ct("rta-trmc.signInSignUpPage.signIn")}</h2>
                                                </div>
                                                <div className="card-body">
                                                    <form className="w-100">
                                                        <Input
                                                            name="email"
                                                            type="email"
                                                            value={formData.email}
                                                            placeholder={ct("rta-trmc.signInSignUpPage.enterEmail")}
                                                            onChange={handleInput}
                                                        />
                                                        <div className="pass-outer">
                                                            <Input
                                                                type="password"
                                                                name="password"
                                                                id="login-password-input"
                                                                placeholder={ct("rta-trmc.signInSignUpPage.enterPassword")}
                                                                onChange={handleInput}
                                                                value={formData.password}
                                                            />
                                                            {isMaskEye ?
                                                                <>
                                                                    <i className="fa fa-eye icon-after"
                                                                        onClick={() =>
                                                                            maskEye(false)}
                                                                    ></i>
                                                                </> : <>
                                                                    <i className="fa fa-eye-slash icon-after"
                                                                        onClick={() =>
                                                                            maskEye(true)}
                                                                    ></i>
                                                                </>
                                                            }
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="pull-left forgot-pass-container" >
                                                                <span className="font-15 theme-font pointer" onClick={forgotPass}>
                                                                    {ct("rta-trmc.signInSignUpPage.forgetPassword")}
                                                                </span>
                                                            </div>
                                                            <button className="btn float-right login-btn" onClick={handleFormSubmit}>
                                                                {ct("rta-trmc.signInSignUpPage.signIn")}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="card-footer">
                                                    <div className="d-flex justify-content-center links mb-2">
                                                        <span className="font-15 black-font">{ct("rta-trmc.signInSignUpPage.dontHaveAcc")}
                                                            <span className="signup-btn theme-font pointer"
                                                                onClick={() => setIsLogin(false)}
                                                            > {ct("rta-trmc.signInSignUpPage.signUp")}</span>
                                                        </span>
                                                    </div>

                                                    {

                                                        getBaseConfig("guestUser") == true && <div className="d-flex justify-content-center links">
                                                            <span className="font-15 theme-font pointer"
                                                                onClick={handleGuest}
                                                            >{ct("rta-trmc.signInSignUpPage.continueAsGuest")}
                                                            </span>
                                                        </div>
                                                    }

                                                </div>
                                            </>
                                            }
                                        </> : <>
                                            <div className="login-text-pane">
                                                <h2 className="login-text text-left">{ct("rta-trmc.signInSignUpPage.signUp")}</h2>
                                            </div>
                                            <div className="card-body">
                                                <form className="w-100">
                                                    <Input
                                                        name="email"
                                                        type="email"
                                                        placeholder={ct("rta-trmc.signInSignUpPage.enterEmail")}
                                                        onChange={handleInput}
                                                        value={formData.email}

                                                    />
                                                    <Input
                                                        type="text"
                                                        name="username"
                                                        placeholder={ct("rta-trmc.signInSignUpPage.enterUsername")}
                                                        onChange={handleInput}
                                                        value={formData.username}

                                                    />

                                                    <div className="pass-outer">
                                                        <Input
                                                            type="password"
                                                            name="password"
                                                            id="login-password-input"
                                                            placeholder={ct("rta-trmc.signInSignUpPage.enterPassword")}
                                                            value={formData.password}
                                                            onChange={handleInput}
                                                        />
                                                        {isMaskEye ?
                                                            <>
                                                                <i className="fa fa-eye icon-after"
                                                                    onClick={() =>
                                                                        maskEye(false)}
                                                                ></i>
                                                            </> : <>
                                                                <i className="fa fa-eye-slash icon-after"
                                                                    onClick={() =>
                                                                        maskEye(true)}
                                                                ></i>
                                                            </>
                                                        }
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="pull-left forgot-pass-container" >
                                                            <span className="font-15 theme-font pointer"
                                                                onClick={() => setIsLogin(true)}
                                                            >{ct("rta-trmc.signInSignUpPage.backToSignIn")}
                                                            </span>
                                                        </div>
                                                        <button className="btn float-right login-btn"
                                                            onClick={handleFormSubmit}
                                                        >{ct("rta-trmc.signInSignUpPage.signUp")}</button></div>
                                                </form>

                                            </div>
                                            {getBaseConfig("guestUser") == true &&
                                                <div className="card-footer">
                                                    <div className="d-flex justify-content-center links">
                                                        <span className="font-15 theme-font pointer"
                                                            onClick={handleGuest}
                                                        >{ct("rta-trmc.signInSignUpPage.continueAsGuest")}
                                                        </span>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

const mapStateToProps = (state) => {

    return {
        loadingShow: state[FEATURE_CUSTOM_REDUX].showLoader,
        dashboardLogin: state[FEATURE_CUSTOM_REDUX].dashboardLogin,
        // isUserLogin: state["features/welcome-dashboard"].isUserLogin,
        // getAuthCode: state["features/welcome-dashboard"].userAccessToken,
        // businessIdProp: state["features/welcome-dashboard"].businessId,
        // businessAllList: state["features/welcome-dashboard"].businessAllList,
        // loadingShow: state["features/welcome-dashboard"].loadingShow,
        // loaderAdditionalDetail: state["features/welcome-dashboard"].loaderAdditionalDetail,
        // authRemoved: state["features/welcome-dashboard"].authRemoved,
        // willRevive: state["features/welcome-dashboard"].willRevive,
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
    }
}

export default translate(connect(mapStateToProps)(Login));